var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7507 1.66667C7.62119 1.66677 6.50809 1.93698 5.50425 2.45475C4.50041 2.97252 3.63494 3.72285 2.98006 4.64313C2.32518 5.56341 1.89987 6.62696 1.73962 7.74504C1.57937 8.86312 1.68882 10.0033 2.05885 11.0705C2.42887 12.1377 3.04874 13.1009 3.86673 13.8798C4.68472 14.6587 5.67712 15.2307 6.76113 15.548C7.84514 15.8654 8.98932 15.9189 10.0982 15.7041C11.2071 15.4893 12.2486 15.0125 13.1357 14.3133L16.179 17.3567C16.3362 17.5085 16.5467 17.5925 16.7652 17.5906C16.9837 17.5887 17.1927 17.501 17.3472 17.3465C17.5017 17.192 17.5894 16.983 17.5913 16.7645C17.5932 16.546 17.5092 16.3355 17.3574 16.1783L14.314 13.135C15.1374 12.0905 15.65 10.8353 15.7933 9.51311C15.9366 8.19088 15.7047 6.85502 15.1242 5.65842C14.5437 4.46181 13.6381 3.4528 12.511 2.74686C11.3838 2.04093 10.0807 1.66658 8.7507 1.66667ZM3.33403 8.75001C3.33403 7.31342 3.90472 5.93567 4.92054 4.91984C5.93636 3.90402 7.31411 3.33334 8.7507 3.33334C10.1873 3.33334 11.565 3.90402 12.5809 4.91984C13.5967 5.93567 14.1674 7.31342 14.1674 8.75001C14.1674 10.1866 13.5967 11.5643 12.5809 12.5802C11.565 13.596 10.1873 14.1667 8.7507 14.1667C7.31411 14.1667 5.93636 13.596 4.92054 12.5802C3.90472 11.5643 3.33403 10.1866 3.33403 8.75001Z",
    fill: "#ABB3BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f4156a35ced2122b23bcbf846f5aa8dd.svg";
export { ForwardRef as ReactComponent };